import Box from "@/common/components/Box"
import Button from "@/common/components/Button"
import { ChangeHistory } from "@/common/components/ChangeHistory"
import { LeadHeader } from "@/features/privateCompanyLeadsFunnel/components/LeadHeader"
import { ResponsibleSection } from "@/features/privateCompanyLeadsFunnel/components/ResponsibleSection"
import useAdvancePrivateCompanyLead from "@/features/privateCompanyLeadsFunnel/hooks/useAdvancePrivateCompanyLead"
import usePrivateCompanyLeadForm from "@/features/privateCompanyLeadsFunnel/hooks/usePrivateCompanyLeadForm"
import { LeadFormStateProps } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead"
import { FormProvider } from "react-hook-form"

const LeadRegisteredForm = ({ id, privateCompanyLead }: LeadFormStateProps) => {
  const {
    formMethods,
    updateLeadOnSuccess,
    onError,
    serverError,
  } = usePrivateCompanyLeadForm({ privateCompanyLead });

  const {
    mutate: advancePrivateCompanyLead,
    isPending: advancePrivateCompanyLeadIsPending,
  } = useAdvancePrivateCompanyLead({
    id,
    onSuccess: updateLeadOnSuccess,
    onError
  })

  return (
    <FormProvider {...formMethods}>
      <form>
        <LeadHeader
          privateCompanyLeadId={id}
          display_name={privateCompanyLead.display_name}
          url={privateCompanyLead.general_information?.company_logo?.url}
          showArchiveButton
          archived_at={privateCompanyLead.archived_at}
          buttons={
            <Button
              type="button"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              variant="default"
              onClick={() => advancePrivateCompanyLead()}
              data-testid="access_qualification_button"
              isLoading={advancePrivateCompanyLeadIsPending}
            >
              Iniciar Qualificação
            </Button>
          }
        />
        <div className='flex gap-6'>
          <Box className="w-full flex flex-col gap-6 max-h-[calc(100vh-130px)] overflow-y-auto shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            {serverError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, tente novamente.</p>}
            <ResponsibleSection privateCompanyLead={privateCompanyLead} disabled />
          </Box>
          <ChangeHistory
            logs={privateCompanyLead?.logs || []}
            bodyClassName="max-h-[calc(100vh-186px)]"
          />
        </div>
      </form>
    </FormProvider>
  )
}

export default LeadRegisteredForm
